import { TextShow } from 'Utils/Helpers/TextShow';
import { useDispatch } from 'react-redux';
import * as icons from 'react-bootstrap-icons';
import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';
import { changeTimeStatus } from '../../../../../Redux/slices/globalSlice';

export default function Times({ totalTimes }) {
    const dispatch = useDispatch();

    const handleChangeTimes = (event) => {
        dispatch(changeTimeStatus({
        index: +event.target.name,
        status: event.target.checked
        }))
    }

    return (
        <div className='mt-4'>
            <TextShow
                title={"تنظیم ساعت های مجاز نوبت دهی"}
                icon={<icons.Clock size={18} />}
                justText
                className={'no-hide text-muted'}
            />
            <div className='group-checkbox'>
            {
                totalTimes ? totalTimes.map((items, index) => {
                return (
                    <div className='times-checkbox'>
                        <FormControlLabel
                            key={`fc-${index}`}
                            control={<Checkbox
                                name={index}
                                sx={{margin: 0, padding: 0, marginLeft: '3px'}}
                                checked={items.status}
                                onChange={handleChangeTimes}
                            />}
                            label={items.name}
                        />
                    </div>
                )
                }) : <small className='each-status w-100 text-center mb-2'>{"زمان‌ها به درستی بارگزاری نشده‌اند"}</small>
            }
            </div>
        </div>
    );
}